/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S3_HeadingInputs */

const tr_hakkimizda_s3_heading = /** @type {(inputs: Hakkimizda_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknoloji Altyapımız`)
};

const en_hakkimizda_s3_heading = /** @type {(inputs: Hakkimizda_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology Infrastructure`)
};

const de_hakkimizda_s3_heading = /** @type {(inputs: Hakkimizda_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Technologie-Infrastruktur`)
};

const ru_hakkimizda_s3_heading = /** @type {(inputs: Hakkimizda_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша технологическая инфраструктура`)
};

/**
* | output |
* | --- |
* | "Our Technology Infrastructure" |
*
* @param {Hakkimizda_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s3_heading = /** @type {((inputs?: Hakkimizda_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s3_heading(inputs)
	if (locale === "de") return de_hakkimizda_s3_heading(inputs)
	if (locale === "ru") return ru_hakkimizda_s3_heading(inputs)
	return tr_hakkimizda_s3_heading(inputs)
});